import { FormHelperText, Grid, TextField } from "@mui/material";
import { MprcFormSubHeader } from "components";
import { MprcSwitch } from "components/MprcSwitch";
import React from "react";
import { useTranslation } from "react-i18next";
import { MAX_IA_ALTERNATIVES } from "views/assessment/common/assessment";
import { GeneratorOptions } from "views/assessment/generatorQuestion/GeneratorQuestionAI";
import { GeneratorQuestionAITitle } from "views/assessment/generatorQuestion/GeneratorQuestionAITitle";

/////////////////////////////////////////////////////////////////////////////////

interface IPros {
    header: React.ReactNode;
    option: GeneratorOptions;
    forSurvey: boolean;
    hasRecommend: boolean;
    onChange: (option: GeneratorOptions) => void;
}

/////////////////////////////////////////////////////////////////////////////////

export const GeneratorQuestionAIOption: React.FC<IPros> = (props) => {
    const { header, option, forSurvey, hasRecommend, onChange } = props;

    const { t } = useTranslation("assessment");

    ///
    function handleUpdateOption(name: keyof GeneratorOptions, v: any) {
        onChange({ ...option, [name]: v });
    }

    return (
        <Grid container direction="column" spacing={4}>
            <Grid>
                <GeneratorQuestionAITitle header={header} />
            </Grid>
            <Grid>
                <MprcFormSubHeader
                    title={t("GeneratorQuestionAI.FirstPage.NumberOfQuestionsLabel")}
                />
                <TextField
                    name="numberOfQuestions"
                    type="number"
                    autoComplete="off"
                    autoFocus
                    margin="dense"
                    value={option.numberOfQuestions}
                    onChange={(e) => handleUpdateOption("numberOfQuestions", e.target.value)}
                    slotProps={{
                        input: {
                            inputProps: {
                                max: 20,
                                min: 1
                            }
                        }
                    }}
                    error={option.numberOfQuestions < 0 || option.numberOfQuestions > 20}
                />
                {(option.numberOfQuestions < 0 || option.numberOfQuestions > 20) &&
                    <FormHelperText error>
                        {t("GeneratorQuestionAI.FirstPage.NumberOfQuestionsHelpText")}
                    </FormHelperText>
                }
            </Grid>
            <Grid>
                <MprcFormSubHeader
                    title={t("GeneratorQuestionAI.FirstPage.NumberOfAlternativesLabel")}
                />
                <TextField
                    name="numberOfAlternatives"
                    type="number"
                    autoComplete="off"
                    margin="dense"
                    value={option.numberOfAlternatives}
                    onChange={(e) => handleUpdateOption("numberOfAlternatives", e.target.value)}
                    slotProps={{
                        input: {
                            inputProps: {
                                max: MAX_IA_ALTERNATIVES,
                                min: 1
                            }
                        }
                    }}
                    error={option.numberOfAlternatives < 0 || option.numberOfAlternatives > MAX_IA_ALTERNATIVES}
                />
                {(option.numberOfAlternatives < 0 || option.numberOfAlternatives > MAX_IA_ALTERNATIVES) &&
                    <FormHelperText error>
                        {t("GeneratorQuestionAI.FirstPage.NumberOfAlternativesHelpText", { count: MAX_IA_ALTERNATIVES })}
                    </FormHelperText>
                }
            </Grid>
            {
                !forSurvey &&
                <Grid>
                    <MprcSwitch
                        label={t("GeneratorQuestionAI.FirstPage.CreateFeedbackLabel")}
                        checked={option.createFeedback}
                        onChange={(e) => handleUpdateOption("createFeedback", e.target.checked)}
                        helperText={t("GeneratorQuestionAI.FirstPage.CreateFeedbackHint")}
                    />
                </Grid>
            }
            {
                hasRecommend &&
                <Grid>
                    <MprcSwitch
                        label={t("GeneratorQuestionAI.FirstPage.RecommendPubLabel")}
                        checked={option.recommentPub}
                        onChange={(e) => handleUpdateOption("recommentPub", e.target.checked)}
                        helperText={t("GeneratorQuestionAI.FirstPage.RecommendPubHint")}
                    />
                </Grid>
            }
        </Grid>
    );
};
